import { SortElement } from "./Search";
import { CoachStatuses } from "./UserStatus";

export enum ReportType {
  PROMPT_ENGAGEMENT_REPORT = "PROMPT_ENGAGEMENT_REPORT",
  PLAYERS_REPORT = "PLAYERS_REPORT",
  REMITTANCE_REPORT = "REMITTANCE_REPORT",
  FEATURE_ENGAGEMENT_REPORT = "FEATURE_ENGAGEMENT_REPORT",
}

export interface SearchAssistantsQuery {
  searchTerm?: string;
}

export interface SearchCoachesQuery {
  searchTerm?: string;
  coachStatuses?: CoachStatuses[];
  hideDemoAccounts?: boolean;
}

export interface Page<T> {
  content: T[];
  totalPages?: number;
  totalElements?: number;
  last?: boolean;
  sort?: SortElement;
  numberOfElements?: number;
  first?: boolean;
  size?: number;
  number?: number;
  empty?: boolean;
}

export interface FilterType {
  key: number;
  text: string;
  value: string | number;
}
